module.exports = __webpack_public_path__ + "static/img/cx.2eee9616.svg";